import mangaedImg from "public/privateCloud/managed-unmanaged.png";

export const WHY_ONEMIND_CONSTANTS = {
  title: "Secure , Monitored & Managed Microsoft 365 — The OneMind Way ",
  points1: [
    "Managed Firewall (Cisco) with threat prevention, SD-WAN & dual WAN failover",
    "24/7/365 Network Monitoring and proactive resolution",
    "SentinelOne EDR + Vigilance MDR – fully managed threat detection & response",
    "Backup with nightly patch management",
  ],
  list: {
    title: "Audit and Alerting",
    points: [
      "Real-time alerts via Microsoft Defender for Cloud Apps integration",
      "Policy match logs, false positive reviews, and automated case workflows",
    ],
  },
  points2: [
    "Microsoft 365 Backup, secure Exchange, OneDrive, SharePoint & Teams data",
    "Data Protection & Compliance",
  ],
  image: mangaedImg,
};
